import z from "zod";

export const searchParamsSchema = z.object({
	token: z.string().optional(),
	linkId: z.string().optional(),
	terminationToken: z.string().optional(),
	// Signup success params (passthrough)
	success: z.coerce.boolean().optional(),
	stripe_success: z.coerce.boolean().optional(),
});
export type PartnerSearchParams = z.infer<typeof searchParamsSchema>;

export type PartnerFlow =
	| { type: "none" }
	| { type: "referralApproval"; linkId: string; token: string }
	| { type: "stripeConnect"; token: string };
